import styles from './ModalAddToCart.module.scss';
import Minus from '../Icons/Minus';
import Plus from '../Icons/Plus';
import { CrossIcon } from '../Icons/Cross';
import { FC, useState, useCallback, MouseEventHandler, useRef } from 'react';
import clsx from 'clsx';
import { ICartItem } from '../pages/CartPage/components/CartItem/CartItem';
import { useActions } from '../../lib/hooks/useActions';

interface IModalAddToCart {
  data: ICartItem;
  onClose?: () => void;
}
const ModalAddToCart: FC<IModalAddToCart> = ({ data, onClose }) => {
  const [count, setCount] = useState<number | ''>(1);
  const [comment, setComment] = useState<string>('');

  const modal = useRef<HTMLDivElement>(null);
  const handleClose: MouseEventHandler<HTMLButtonElement> = useCallback(() => {
    onClose?.();
  }, [onClose]);

  const { addItem } = useActions();

  const productData: ICartItem = {
    product_id: data.product_id,
    cmmf: data.cmmf,
    name: data.name,
    article_number: data.article_number,
    type: data.type === 'part' ? 'detail' : 'extra',
    available: data.available,
    count: +count,
    status: data.status,
    comment: comment,
  };

  if (data.image) productData.image = data.image;

  return (
    <div className={clsx(styles.ModalAddToCart)} ref={modal}>
      <div className={styles.holder}>
        <div className={styles.header}>
          <h2>Добавить в корзину</h2>
          <button className={styles.close_btn} onClick={handleClose}>
            <CrossIcon />
          </button>
        </div>
        <div className={styles.info}>
          <span>{data.name}</span>
          <span>{data.article_number}</span>
        </div>
        <div className={styles.count}>
          <span>Количество</span>
          <div className={styles.input}>
            <button
              className={styles.prev}
              disabled={+count <= 1}
              onClick={() => setCount((state) => +state - 1)}
            >
              <Minus />
            </button>
            <input
              value={count}
              onInput={(e) =>
                setCount(
                  +(e.target as HTMLTextAreaElement).value < 999 &&
                    +(e.target as HTMLTextAreaElement).value !== 0
                    ? +(e.target as HTMLTextAreaElement).value.replace(
                        /[^0-9]/g,
                        '',
                      )
                    : +(e.target as HTMLTextAreaElement).value === 0
                      ? ''
                      : +(e.target as HTMLTextAreaElement).value
                            .replace(/[^0-9]/g, '')
                            .slice(0, 3) === 0
                        ? ''
                        : +(e.target as HTMLTextAreaElement).value
                            .replace(/[^0-9]/g, '')
                            .slice(0, 3),
                )
              }
              onBlur={() => count === '' && setCount(1)}
            />
            <button
              className={styles.next}
              disabled={+count >= 999}
              onClick={() => setCount((state) => +state + 1)}
            >
              <Plus />
            </button>
          </div>
        </div>
        <div className={styles.comment}>
          <span>Комментарий</span>
          <textarea
            placeholder="Комментарий"
            value={comment}
            onInput={(e) =>
              setComment((e.target as HTMLTextAreaElement).value.slice(0, 250))
            }
          ></textarea>
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.button_add}
            onClick={(e) => {
              handleClose(e);
              addItem(productData);
            }}
          >
            Добавить в корзину
          </button>
          <button className={styles.button_cancel} onClick={handleClose}>
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalAddToCart;
